import { createReducer } from '@reduxjs/toolkit';

const initialState = {
  // create
  saveRequestLoading: false,
  saveData: {},
  saveFailed: {},

  // get all
  getRequestLoading: false,
  getListData: null,
  getListDataFailed: null,
};

export const clientIncomeReducer = createReducer(initialState, {
  //save
  postClientIncomeRequest: (state) => {
    state.saveRequestLoading = true;
    state.saveData = {};
    state.saveFailed = {};
  },
  postClientIncomeSuccess: (state, action) => {
    state.saveRequestLoading = false;
    state.saveData = action.payload;
    state.saveFailed = {};
  },
  postClientIncomeFailed: (state, action) => {
    state.saveRequestLoading = false;
    state.saveData = {};
    state.saveFailed = action.payload;
  },

  //get all
  getClientIncomeRequest: (state) => {
    state.getRequestLoading = true;
    state.getListData = null;
    state.getListDataFailed = {};
  },
  getClientIncomeSuccess: (state, action) => {
    state.getRequestLoading = false;
    state.getListData = action.payload;
    state.getListDataFailed = {};
  },
  getClientIncomeFailed: (state, action) => {
    state.getRequestLoading = false;
    state.getListData = null;
    state.getListDataFailed = action.payload;
  },
});
